import React, { useCallback, useState } from 'react';
import avatar from '../assets/avatar.png';

const ImageAvatar = ({
  imageUrl,
  className
}: {
  imageUrl: string;
  className: string;
}) => {
  const [imageLoaded, setImageLoaded] = useState(true);
  const [imageError, setImageError] = useState(false);

  const showImage = useCallback(() => {
    if (imageLoaded && !imageError) {
      return (
        <img
          src={imageUrl}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
          className={className}
        />
      );
    }
    return <img src={avatar} className={className} />;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageLoaded, imageError]);

  return <div>{showImage()}</div>;
};

export default ImageAvatar;
